import { ActionReducerMap } from '@ngrx/store';
import { coreReducer, CoreState } from './core.reducer';
import { authenticationReducer, AuthenticationState } from './authentication.reducer';
import { storeReducer, StoreState } from './store.reducer';
import { storeChannelReducer, StoreChannelState } from './store-channel.reducer';
import { stateReducer, StateState } from './state.reducer';
import { roleReducer, RoleState } from './role.reducer';
import { licenseReducer, LicenseState } from './license.reducer';
import { saleChannelReducer, SaleChannelState } from './sale-channel.reducer';
import { userReducer, UserState } from './user.reducer';
import { languageReducer, LanguageState } from './language.reducer';
import { businessSettingReducer, BusinessSettingState } from './business-setting.reducer'
import { resellerReducer, ResellerState } from './reseller.reducer';
import { moduleReducer, ModuleState } from './module.reducer';
import { accountReducer, AccountState } from './account.reducer';
import { apkReducer, ApkState } from './apk.reducer';
import { delimiterSettingReducer, DelimiterSettingState } from './delimiter-setting.reducer';
import { auditReducer, AuditState } from './audit.reducer';
import { integrationReducer, IntegrationState } from './integration.reducer';

export { AuthenticationState, authenticationReducer } from "./authentication.reducer";
export { StoreState, storeReducer } from "./store.reducer";
export { metaReducers, storageReducer } from "./storage-reducers";
export { CoreState, coreReducer } from "./core.reducer";
export { StoreChannelState, storeChannelReducer } from "./store-channel.reducer";
export { StateState, stateReducer } from "./state.reducer";
export { RoleState, roleReducer } from "./role.reducer";
export { LicenseState, licenseReducer } from "./license.reducer";
export { SaleChannelState, saleChannelReducer } from "./sale-channel.reducer";
export { UserState, userReducer } from './user.reducer';
export { LanguageState, languageReducer } from './language.reducer';
export { BusinessSettingState, businessSettingReducer } from './business-setting.reducer'
export { ResellerState, resellerReducer } from './reseller.reducer';
export { ModuleState, moduleReducer } from './module.reducer';
export { AccountState, accountReducer } from './account.reducer';
export { ApkState, apkReducer } from './apk.reducer';
export { DelimiterSettingState, delimiterSettingReducer } from './delimiter-setting.reducer';
export { AuditState, auditReducer } from './audit.reducer';
export { IntegrationState, integrationReducer } from './integration.reducer';

export interface AppState {
  core: CoreState;
  authentication: AuthenticationState;
  store: StoreState;
  state: StateState;
  storeChannel: StoreChannelState;
  role: RoleState;
  license: LicenseState;
  saleChannel: SaleChannelState;
  user: UserState;
  language: LanguageState;
  businessSetting: BusinessSettingState;
  reseller: ResellerState;
  module: ModuleState;
  account: AccountState;
  apk: ApkState;
  delimiterSetting: DelimiterSettingState;
  audit: AuditState;
  integration: IntegrationState;
}

export const reducers: ActionReducerMap<AppState> = {
  core: coreReducer,
  authentication: authenticationReducer,
  store: storeReducer,
  state: stateReducer,
  storeChannel: storeChannelReducer,
  role: roleReducer,
  license: licenseReducer,
  saleChannel: saleChannelReducer,
  user: userReducer,
  language: languageReducer,
  businessSetting: businessSettingReducer,
  reseller: resellerReducer,
  module: moduleReducer,
  account: accountReducer,
  apk: apkReducer,
  delimiterSetting: delimiterSettingReducer,
  audit: auditReducer,
  integration: integrationReducer,
};